import { TechnologiesModule } from '@/core/modules/digital-footprint/technologies/technologies.module'
import { Analytics } from '@core/services/mixpanel'
import { SelectionOption } from '@atbay/component-lib'
import { useState } from 'react'

const useAddTechnology = () => {
    const [selectedTechnologies, setSelectedTechnologies] =
        useState<TTechnologyMap>({})
    const { data: accountTechnologies, loading } = TechnologiesModule.useStore()
    const [allTechnologies, setAllTechnologies] = useState<TSlimTechnology[]>(
        []
    )

    const fetchTechnologies = useCallback(async () => {
        const technologies = await TechnologiesModule.getAllTechnologies()
        setAllTechnologies(technologies)
    }, [])

    useEffect(() => {
        fetchTechnologies()
    }, [])

    const onSelectTechnology = (value: SelectionOption) => {
        if (value.id === -1 || !value.key) return

        Analytics.event('SEM::user_selected_technology', {
            technology: value.value,
        })

        setSelectedTechnologies(
            (prev) =>
                ({
                    ...prev,
                    [value.key as string]: value,
                }) as TTechnologyMap
        )
    }

    const onRemoveTechnology = (value: TTechnologyOption) => {
        Analytics.event('SEM::user_removed_technology', {
            technology: value.value,
        })

        setSelectedTechnologies((prev) => {
            const updatedTechs = { ...prev }
            delete updatedTechs[value.key]
            return updatedTechs
        })
    }

    const addTechnologies = () => {
        const isTechnologiesAdded = TechnologiesModule.addTechnologies(
            Object.values(selectedTechnologies)
        )
        return isTechnologiesAdded
    }

    const relevantTechnologiesOptions = allTechnologies
        .filter(
            ({ name: allTechName }) =>
                !accountTechnologies.some(
                    ({ name: accountTechName }) =>
                        accountTechName === allTechName
                )
        )
        .map(({ name, id }, index) => {
            return {
                value: name,
                id: index,
                key: id,
            }
        })

    const existingTechnologiesOptions = accountTechnologies.map(
        ({ name, id }, index) => {
            return {
                value: `${name} - already exists`,
                id: index + relevantTechnologiesOptions.length,
                key: id,
                isDisabled: true,
            }
        }
    )

    const technologiesOptions = [
        ...relevantTechnologiesOptions,
        ...existingTechnologiesOptions,
    ].filter((technology) => {
        return !selectedTechnologies[technology.key]
    })

    return {
        selectedTechnologies,
        onRemoveTechnology,
        onSelectTechnology,
        addTechnologies,
        technologiesOptions,
        isLoading: loading,
    }
}

export default useAddTechnology
